import { getAxios } from './axios'
import config from 'config'
const getDataM = () => config.dataM
// dataM
export const dataM = () => {
  return getAxios({
    baseURL: getDataM(),
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
